import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { IoEyeSharp } from "react-icons/io5";
import { PiEyeSlashFill } from "react-icons/pi";
import Loader from "../Loader/Loader";
import { NotificationManager } from "react-notifications";
import { MdDelete } from "react-icons/md";

import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@material-tailwind/react";
import UserToggle from "./UserToggle";
import "../User/style.css";

function User({ bar, BaseUrl }) {
  const [eye, seteye] = useState(false);
  const [login, setlogin] = useState(false);
  const [ID, setID] = useState();
  const [open, setOpen] = useState(false);
  const [data, setdata] = useState([]);
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("TOKEN")}`,
    withCredentials: true,
    
  };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const Handler_register = (data, e) => {
    setlogin(!login);
    axios
      .post(`${BaseUrl}/user/create`, data,{headers:headers})
      .then((res) => {
        loaddata();
        console.log(res)
        NotificationManager.success(res.data.message);
        setlogin(false);
        reset({
          name: "",
          email: "",
          password: "",
        });
      })
      .catch((err) => {
        setlogin(false);
        if (err.response.data.message.email) {
          NotificationManager.error(err.response.data.message.email);
        } else {
          NotificationManager.error(err.response.data.message);
        }
      });
  };
  const Handler_eye = () => {
    seteye(!eye);
  };

  const Handler_DeleteModalOpen = (id) => {
    setID(id);
    setOpen(!open);
  };
  const handler_delete = () => {
    console.log(ID,"IDDDD")
    axios
      .delete(`${BaseUrl}/user/${ID}`,{headers:headers})
      .then((res) => {
        NotificationManager.success("اطلاعات با موفقیت حذف شد");
        loaddata();
      })
      .catch((err) => {
        NotificationManager.error(err.response.data.message);
      });
  };
  const loaddata = () => {
    axios
      .get(`${BaseUrl}/user/all`,{headers:headers})
      .then((res) => {
        console.log(res.data.User,"lllllllkkkkjjjjj")
        setdata(res.data);
        console.log(data);
      })
      .catch((err) => {});
  };
  useEffect(() => {
    loaddata();
  }, []);


  return (
    <>
      <div
        className={`${
          bar ? "md:block  col-span-10 mr-16" : "md:block  col-span-11 mr-10"
        }`}
      >
        <div className="text-4xl  text-orange-700 mb-5 w-1/6 rounded-l-xl bg-slate-700 text-center relative left-8 p-1 mt-10">
          افزودن کاربر جدید
        </div>
        <div className="w-full flex justify-evenly">
          <div class="mb-2 flex flex-col w-full  border-gray-300">
            <label className="mb-2 text-2xl">نام کاربر</label>
            <input
              placeholder="نام کاربری"
              type="text"
              {...register("name", {
                required: "نام کاربری الزامی است",
                maxLength: {
                  value: 100,
                  message: "نام کاربر نباید بیشتر از 100 کاراکتر باشد",
                },
              })}
              class="w-3/4 border-gray-200  focus:outline-none bg-white py-2 px-3  text-xl "
              autocomplete="off"
            />
            {errors.name && (
              <p className="text-red-800">*{errors.name?.message}</p>
            )}
          </div>
          <div class="mb-2 flex flex-col w-full  border-gray-300">
            <label className="mb-2 text-2xl"> ایمیل</label>
            <input
              placeholder="ایمیل"
              type="email"
              {...register("email", {
                required: "ایمیل الزامی است",
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "ایمیل نامعتبر است",
                },
              })}
              class="w-3/4 border-gray-200  focus:outline-none bg-white py-2 px-3  text-xl "
              autocomplete="off"
            />
            {errors.email && (
              <p className="text-red-800">*{errors.email?.message}</p>
            )}
          </div>

          <div class="mb-2 flex flex-col w-full  border-gray-300">
            <label className="mb-2 text-2xl">پسورد</label>
            <div className="flex items-center">
              <input
                placeholder="رمز عبور"
                type={eye ? "text" : "password"}
                {...register("password", {
                  required: "پسورد را وارد کنید",
                  minLength: {
                    value: 8,
                    message: "پسورد نباید کمتر از 8 کاراکتر باشد",
                  },
                })}
                class="w-3/4  focus:outline-none bg-white pr-10 py-2 px-3 focus:!border-hidden text-xl border-gray-200 ml-2"
                autocomplete="off"
              />

              {eye ? (
                <PiEyeSlashFill
                  className="text-xl text-orange-700 cursor-pointer"
                  onClick={Handler_eye}
                />
              ) : (
                <IoEyeSharp
                  className="text-xl text-orange-700 cursor-pointer"
                  onClick={Handler_eye}
                />
              )}
            </div>
            {errors.password && (
              <p className="text-red-800">*{errors.password?.message}</p>
            )}
          </div>
        </div>
        {login ? (
          <Loader />
        ) : (
          <button
            onClick={handleSubmit(Handler_register)}
            class="w-1/6 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-md transition-all duration-200 ease-in py-2 px-4"
          >
            ثبت نام
          </button>
        )}

        <div className="flex mt-1 ">
          <div className="container   m-auto ">
            <div className="bg-white p-4 m-4 h-auto rounded-md shadow-md shadow-slate-200 ">
              <div class="relative overflow-x-auto shadow-md sm:rounded-lg ">
                <div className="w-full h-[34rem] overflow-y-auto">
                  <table class="w-full table-auto overflow-scroll text-sm text-left text-gray-500 dark:text-gray-400 ">
                    <thead class="text-xs  uppercase bg-gradient-to-r from-sky400 to-sky700 text-white !rounded-md dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" class="px-6 py-3 text-xl text-center">
                          ردیف
                        </th>
                        <th scope="col" class="px-6 py-3 text-xl text-center">
                          نام کاربر
                        </th>
                        <th scope="col" class="px-6 py-3 text-xl text-center">
                          ایمیل کاربر
                        </th>
                        <th scope="col" class="px-6 py-3 text-xl text-center">
                          نوع کاربر
                        </th>
                        <th scope="col" class="px-6 py-3 text-xl text-center">
                          عملیات
                        </th>
                      </tr>
                    </thead>
                    {data.User &&
                      data.User.map((item, index) => {
                        return (
                          <tr
                            key={index}
                            class="bg-white border-b dark:bg-gray-800  dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 "
                          >
                            <td class="w-32 py-4 text-center text-xl">
                              {index + 1}
                            </td>
                            <td class="w-32 py-4 text-center text-xl">
                              {item.name}
                            </td>
                            <td class="w-32 py-4 text-center text-xl">
                              {item.email}
                            </td>
                            <td class="w-32 py-4 text-center">
                              <UserToggle item={item} />
                            </td>
                            <td class="w-32 py-4 text-center">
                              <Dialog
                                open={open}
                                handler={() => setOpen(!open)}
                                animate={{
                                  mount: { scale: 1, y: 0 },
                                  unmount: { scale: 0.9, y: -100 },
                                }}
                              >
                                <DialogHeader>حذف اطلاعات</DialogHeader>
                                <DialogBody className="flex items-center justify-center">
                                  آیا از حذف این گزینه مطمئن هستید ؟؟؟
                                  <MdDelete className="text-3xl text-red-800 mr-5" />
                                </DialogBody>
                                <DialogFooter className="">
                                  <Button
                                    variant="gradient"
                                    color="red"
                                    onClick={() => setOpen(!open)}
                                    className="ml-2"
                                  >
                                    <span>نه </span>
                                  </Button>
                                  <Button
                                    variant="gradient"
                                    color="green"
                                    onClick={() => handler_delete()}
                                  >
                                    <span>بله </span>
                                  </Button>
                                </DialogFooter>
                              </Dialog>
                              <button className="p-2 m-auto bg-red-200 px-4 text-red-800 mr-2 rounded-md cursor-pointer  items-center text-lg">
                                <MdDelete
                                  onClick={() =>
                                    Handler_DeleteModalOpen(item.id)
                                  }
                                />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default User;
